export enum SecadorStatusComunicacaoEnum {
    ATIVO = 'Ativo',
    INATIVO = 'Inativo'
}
